import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { LocalStorage, LocalStorageService } from 'ngx-store';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, tap } from 'rxjs/operators';
import { PasswordGrantCreds } from 'src/lib/models/oauth';
import { environment } from '../../environments/environment';
import { AuthResponse, loggedOutUri } from '../../lib/core/authentication/auth.config';
import { AppSettings } from '../app.settings';

//Model
import { Settings } from '../app.settings.model';
import { Profile, ThemeSetting, Url, User } from '../model/users.model';
import { Role } from '../model/role.model';


//Service
import { AuthService } from '../../lib/core/authentication/auth.service';
import { ToastrService } from 'ngx-toastr';

const helper = new JwtHelperService();

@Injectable()
export class LoginService {
  @LocalStorage() companyCode: string;
  @LocalStorage() token: string;
  @LocalStorage() user: User;
  @LocalStorage() url: Url;
  @LocalStorage() profile: Profile;
  @LocalStorage() themeSettings: ThemeSetting;
  @LocalStorage() companyName: string;
  @LocalStorage() cloud_storage_path :string;
  @LocalStorage() roles :Role[];
  @LocalStorage() components :any;
  @LocalStorage() version :any;
  
  public settings: Settings;

  constructor(
    private http:                HttpClient,
    public  localStorageService: LocalStorageService,
    public  appSettings:         AppSettings,
    private authenticator:       AuthService,
    private router:              Router,
    private toastr:               ToastrService
  ) {
    this.settings = this.appSettings.settings;
  }

  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  getCompanyDetails(companyCode: string): Observable<Object> {
    const empressData = {
      company: companyCode,
      ver: 30
    }
    return this.http.post(environment.restApiForClientData, empressData, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  getAuthClientId(url: string): Observable<{ id: string }> {
    return this.http.get<{ id: string }>(url + '/tms/getAuthClientId', this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  login(clientCreds: PasswordGrantCreds, companyName: string, companyCode: string, username: string, password: string) {
    console.info(`Client attempts to log into "${companyCode}".`);

    return this.authenticator
      .init(clientCreds)
      .authenticate(username, password)
      .pipe(
        tap((response: AuthResponse) => {
          if(response.admin_user.status == 0){
            this.showAuthenticateErrorToaster();
            this.router.navigate(['logout']);
          }
          else{
            this.components = this.transformArray(response.components);
            this.companyName = companyName;
            this.user = response.admin_user;
            this.companyCode = response.cloud_storage_path;//companyCode;
            this.profile = response.admin_profile;
            this.themeSettings = response.theme_settings;
            this.cloud_storage_path = response.cloud_storage_path;
            this.roles = response.roles;
            this.version = response.frontend_version;
            
            const oldUrl: Url = this.localStorageService.get('url');
  
            this.localStorageService.set<Url>('url', {
              ...oldUrl,
              cloudStorage: response.cloud_storage_path
            });
  
            this.localStorageService.set('cloud_storage_path', response.cloud_storage_path);
            this.localStorageService.set('fileStorage', response.cloud_storage_path);
            this.localStorageService.set('roles', response.roles);
            this.localStorageService.set('components', this.components);
            this.localStorageService.set('component_modules', response.components);

            const api: Url = {
              rest: environment.protocolIdentifier + environment.restUrl,
              app: environment.protocolIdentifier + environment.appUrl,
              fileStorage: response.cloud_storage_path,
              cloudStorage: response.cloud_storage_path
            };
            
            this.url = api;
            console.log('reloading...');
            window.location.reload();
          }
        }),
        catchError(this.handleError)
      );
  }

  showAuthenticateErrorToaster() {
    this.toastr.error('', 'Authorization Error!', {
      timeOut: 5000,
      positionClass: 'toast-top-full-width',
      progressBar: true
    });
  }

  logOut() {
    setTimeout(() => {
      this.settings.theme.skin = 'light';
    });
    
    this.localStorageService.clear('prefix');
    this.authenticator.revokeToken()
      .subscribe({
        complete: () => this.router.navigate([ loggedOutUri ])
      });
  }

  transformArray(tms_components){
    let cs = [];
    if(tms_components){
      tms_components.forEach(c=>{
        cs.push(c.name);
      });
    }
    
    return cs;
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      console.log(error.error.status)
    }
    console.log(errorMessage);

    return throwError(errorMessage);
  }
}